module.exports = __webpack_public_path__ + "img/resize-icon-br.14b704f5.svg";